import * as React from "react";

import style from "components/file-sharing/file-sharing.scss";

export type FileUploadStatus = "QUEUED" | "UPLOADING" | "DONE" | "FAILED";

const UploadStatusIcon = ({ status }: { status: FileUploadStatus }): JSX.Element => {
    switch (status) {
        case "QUEUED":
            return (
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                    <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="1.5" />
                </svg>
            );
        case "UPLOADING":
            return (
                <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    className={style.uploadStatusIconSpinner}
                    aria-hidden="true"
                >
                    <circle
                        cx="7"
                        cy="7"
                        r="6"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeDasharray="28 9"
                        strokeLinecap="round"
                    />
                </svg>
            );
        case "DONE":
            return (
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                    <circle cx="7" cy="7" r="7" fill="currentColor" />
                    <polyline
                        points="3.5,7 5.5,9.5 10.5,4.5"
                        stroke="white"
                        strokeWidth="1.5"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "FAILED":
            return (
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                    <circle cx="7" cy="7" r="7" fill="currentColor" />
                    <line x1="4.5" y1="4.5" x2="9.5" y2="9.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                    <line x1="9.5" y1="4.5" x2="4.5" y2="9.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
            );
    }
};

export default UploadStatusIcon;
